import React from "react";
import {useNavigate} from "react-router-dom";

function NotFound() {
    const navigate = useNavigate();
    return (
        <div className="flex items-center flex-col justify-center text-offwhite">
            <div className="text-[200px] mt-[100px] font-['Jersey_10']">
                404
            </div>

            <div className="text-[40px] relative -top-[90px] flex items-start font-['Jersey_10'] gap-4 leading-[36px]">
                <img
                    src={`${process.env.PUBLIC_URL}/img/piccolo.webp`}
                    className="w-[32px] h-[87px] z-5 relative -top-3"
                    alt=""
                />
                <div className="flex flex-col">
                    <span>Page Not</span>
                    <span>Found</span>
                </div>
            </div>
            <div
                onClick={() => navigate("/")}
                className="text-[16px] underline cursor-pointer flex flex-row gap-2"
            >
                Take me home, Frankly roads...
                <img
                    src={`${process.env.PUBLIC_URL}/img/bus.png`}
                    className="w-[32px] h-[31px]"
                    alt=""
                />
            </div>
        </div>
    );
}

export default NotFound;